import { requst } from '../config'

export const postUploadBatchApi = file => {
    const url = `/map/border/uploadBatch`
    const formData = new FormData()
    formData.append('files', file)
    return requst({
        url,
        method: 'post',
        params: {
            type: 'kml',
        },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}

export const postBoundariesApi = (params, modalAddNew) => {
    const url = `/map/border`
    if (modalAddNew) {
        return requst.post(url, params)
    } else {
        return requst.put(url, params)
    }
}

export const getBoundariesListApi = projectId => {
    const url = `/map/border/list?projectId=${projectId}`
    return requst.get(url)
}

export const getBoundariesIdApi = id => {
    const url = `/map/border/${id}`
    return requst.get(url)
}

export const getBoundariesDeleteApi = id => {
    const url = `/map/border/${id}`
    return requst.delete(url)
}

// 下载边界
export const getDownBoundariesIdApi = id => {
    const url = `/map/border/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}
